//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    isBusy: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      badge: {},
      color: null,
      name: null,
      size: null
    };
  },
  computed: {
    value: function value() {
      return this.isBusy || this.$isBusy ? "autorenew" : this.name;
    }
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.badge = this.spec.badge || {};
      this.color = this.spec.color || this.$builtinColor(this.spec.styleClasses);
      Utils.type.ifObject(this.spec.fa, function (fa) {
        _this.name = "fab fa-".concat(fa.name);
        _this.size = fa.size;
      });
      Utils.type.ifObject(this.spec.material, function (material) {
        _this.name = material.name;
        _this.size = material.size;
      });
    }
  }
};